import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class PurchaseStatusRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/suppliers/purchase/statuses/list');
    }

    async getAll() {
        if (Cache.get('purchase-status')) {
            return Cache.get('purchase-status');
        }

        return this.setPerPage(1000).run().then((res) => {
            Cache.set('purchase-status', res.data);
            return Cache.get('purchase-status');
        });
    }
}
